import { DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { ConnectionAuthKind } from 'shell-models-lib';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { OracleFusionLinkedService } from 'app/model/linkedservice/oracle-fusion.linkedservice';
import { OracleFusionCopySource } from 'app/model/pipeline/copysource/oracle-fusion.copysource';
import { GlobalVariables } from 'app/services/globals';

export const oracleFusionMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(OracleFusionLinkedService).name,
    displayName: stringResources.OracleFusion_DisplayText,
    disabled: !GlobalVariables.enableOracleFusionConnector,
    supportedInTrident: GlobalVariables.enableOracleFusionConnector,
    supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
    supportCopyJobSource: GlobalVariables.enableOracleFusionConnector,
    supportedJobModesAsSource: ['Batch'],
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'OracleFusion'
    },
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    copySourceTypes: [Metamodel.modelFor(OracleFusionCopySource).name],
    copySinkTypes: []
};
